module Meevo.Plugins.SelfCheckInKiosk {
    export function hasPriorVisit() {
        return (addOnServices: IHasPriorVisitAtLocation[], value: boolean = false) => {

            if (!addOnServices) {
                return [];
            }

            return addOnServices.filter((row) => row.hasPriorVisitAtLocation === value);
        };
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .filter('hasPriorVisit', hasPriorVisit);
}
